import type {
  GuidedAnswers,
  GuidedFollowUpId,
  GuidedQuestionId,
  GuidedUnsureFlags,
} from "@/features/blueprints/blueprintTypes";

export type GuidedStep = GuidedQuestionId | `followup:${GuidedFollowUpId}` | "extra" | "review";

export type GuidedSaveState = "idle" | "saving" | "saved" | "error";

export type GuidedQuestion = {
  id: GuidedQuestionId;
  title: string;
  helper: string;
  inputType: "text" | "chips";
  chips?: string[];
  allowUnsure: boolean;
  optionalTextLabel?: string;
};

export type GuidedFollowUp = {
  id: GuidedFollowUpId;
  title: string;
  helper: string;
  type: "chips" | "text";
  options?: string[];
  example?: string;
};

export type GuidedModeState = {
  answers: GuidedAnswers;
  unsureFlags: GuidedUnsureFlags;
};

export const GUIDED_TEXT_MAX_LENGTH = 500;
